import { useTranslation } from "react-i18next";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import React, { useEffect } from "react";
import Input from "components/form/input";
import { isEmpty, isWholeNumber } from "helpers/Helpers";

export interface IOverrideCartsAvailableModalState {
  cartsAvailableInput: string;
}

interface IOverrideCartsAvailableModalProps {
  cartsAvailable: number;
  state: { isOpen: boolean } & IOverrideCartsAvailableModalState;
  update: (newState: IOverrideCartsAvailableModalState) => void;
  close: () => void;
  onOk: () => void;
}

export default function OverrideCartsAvailableModal(props: IOverrideCartsAvailableModalProps) {
  const { cartsAvailable, state, update, close, onOk } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (state.isOpen) {
      update({ cartsAvailableInput: cartsAvailable == null ? "" : String(cartsAvailable) });
    }
  }, [state.isOpen]);

  const cartsAvailableInputValid = isEmpty(state.cartsAvailableInput) || isWholeNumber(state.cartsAvailableInput);

  return (
    <Portal isMounted={state.isOpen}>
      <Sheet
        open={state.isOpen}
        size="small"
        closable
        onCancel={close}
        onOk={onOk}
        okDisabled={!cartsAvailableInputValid}
        title={t("Override Carts Available")}
      >
        <Input
          label={t("Carts Available")}
          value={state.cartsAvailableInput}
          onChange={e => update({ cartsAvailableInput: e.target.value })}
        />
      </Sheet>
    </Portal>
  );
}
